// extracted by css-extract-rspack-plugin
var _1 = "Dh8xTxmWA7rL35fl";
var _2 = "LPQn8jzLMIsSbh4f";
var _3 = "kgZ0e3AXNhsR8D7s";
var _4 = "fUwNyBUu8XkbeW1J";
var _5 = "ZaxoC97G_J4IE9gb";
var _6 = "h4md_adSjcss2EmZ";
var _7 = "dOk8Gy0FIQIA4bUG";
var _8 = "BMKyBFpOz90vQRki";
var _9 = "X5zOoSocjecrqTXP";
var _a = "TYhNAbcDxHcILUQI";
var _b = "DIouGx4qwCkPAGOJ";
var _c = "MZI51XvGCwbsVD7C";
var _d = "U540XCaoRSTmfVRi";
var _e = "OkQgkRFbk5_FU4bA";
var _f = "zKa1xjhFa9kEr_Ef";
var _10 = "Ao2yGNNIBOg8tPeC";
var _11 = "HSmyqYSwJEGRLJIy";
var _12 = "cDM2wuD8dR4Mnjdh";
var _13 = "QBgDeYmDf8EjtP77";
var _14 = "ppBASLwDAjQ_hMBd";
var _15 = "xwa6TTGN0nAiL1SM";
var _16 = "SGNYdXY30_8FYemH";
var _17 = "hrpOfJ26nKADBhas";
var _18 = "lwbZs6v9PIQZ8For";
var _19 = "kmRznO9OS5gzBHKu";
var _1a = "MP5tQb0h7GsBEJb7";
var _1b = "CTjMz5y38ofYYS4w";
export { _1 as "brivityBlue", _2 as "brivityOrange", _3 as "darkBlue", _4 as "gray", _5 as "grayBase", _6 as "intentBuyer", _7 as "intentCandidate", _8 as "intentLandlord", _9 as "intentNone", _a as "intentRecruit", _b as "intentSeller", _c as "intentSellerBuyer", _d as "intentTenant", _e as "statusActiveClient", _f as "statusArchived", _10 as "statusHot", _11 as "statusInactive", _12 as "statusNew", _13 as "statusNurt", _14 as "statusOther", _15 as "statusPast", _16 as "statusPending", _17 as "statusProspectiveClient", _18 as "statusTrash", _19 as "statusUnqual", _1a as "statusWatch", _1b as "yellowOrange" }
